/*
* Copyright(c) 2018. Synergy Systems & Solutions. @link : http://s3india.com 
*
* @module : SendGift
* @file : SendGift.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of SendGift
*
* Created on : 12-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 18-Oct-2019
*/
import React from 'react';
import {Link,Redirect} from 'react-router-dom';
import GiftService from '../../services/GiftService/GiftService';
import UserService from '../../services/UserService/UserService';


class SendGift extends React.Component
{
	constructor(props)
	{
		
		super(props);
		this.state = {
			gift:[],
			fields: {},
            errors: {},
            redirect:0
		};
		this.giftService = new GiftService();
		this.userService = new UserService();	
	}
	renderRedirect() {
		
    if (this.state.redirect===1) {
    	return <Redirect to='/thank-you' />
    }
  	}

	componentDidMount()
	{
		this.giftService.getUserGift().then(response=>{
			this.setState({gift:response});
		});
	}

	renderGift()
	{
		let gift = this.state.gift;
		if(gift.status==='1')
		{
			return(
				<React.Fragment>
				  <figure className="corn-gift"><img src={gift.gift.img} alt={gift.gift.img}/>
				    <div className="default-heading">
				      <h3>{gift.gift.name}</h3>
				    </div>
				   </figure>
        		</React.Fragment>
			)
		}
	}

	sendDetails(e)
	{
		e.preventDefault();

        if(this.handleValidation()){
           this.userService.addUserRecord(this.state.fields).then(response=>{
           		if(response.status==='1')
           		{
           			this.setState({redirect:1});
           		}
           });
           
        }else{
           
        }
	}
	handleValidation(){
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        if(!fields["first_name"]){
           formIsValid = false;
           errors["first_name"] = "Cannot be empty";
        }
        if(!fields["last_name"]){
           formIsValid = false;
           errors["last_name"] = "Cannot be empty";
        }
        if(!fields["address"]){
           formIsValid = false;
           errors["address"] = "Cannot be empty";
        }
        if(!fields["zip_code"]){
           formIsValid = false;
           errors["zip_code"] = "Cannot be empty";
        }
        if(!fields["place"]){
           formIsValid = false;
           errors["place"] = "Cannot be empty";
        }

        /*if(typeof fields["name"] !== "undefined"){
           if(!fields["name"].match(/^[a-zA-Z]+$/)){
              formIsValid = false;
              errors["name"] = "Only letters";
           }        
        }*/

        //Email
        if(!fields["email"]){
           formIsValid = false;
           errors["email"] = "Cannot be empty";
        }

        if(typeof fields["email"] !== "undefined"){
           let lastAtPos = fields["email"].lastIndexOf('@');
           let lastDotPos = fields["email"].lastIndexOf('.');

           if (!(lastAtPos < lastDotPos && lastAtPos > 0 && fields["email"].indexOf('@@') === -1 && lastDotPos > 2 && (fields["email"].length - lastDotPos) > 2)) {
              formIsValid = false;
              errors["email"] = "E-Mail Format ungültig";
            }
       }  

       this.setState({errors: errors});
       return formIsValid;
   }
	handleChange(field, e){         
        let fields = this.state.fields;
        fields[field] = e.target.value;        
        this.setState({fields});
    }

	render()
	{
		return (
			<React.Fragment>
				{this.renderRedirect()}
			      <div className="content-box-area ">
			
      <div className="progress-bar large-Width"></div>      
        <div className="default-heading fontSize margbotmNone">
          <h2>Ihr Geschenk​​</h2>
        </div>        
        <div className="paragraph-area text-center">
        <p>Sie haben folgendes Geschenk gewahlt</p>
        {this.renderGift()}
        <p>​Wir belohnen möchten Ihr Adresseangaben, um, Ihnen dieses <br/> zukommen zu lassen.</p>
        </div> 
        <div className="form-area maxWidth">
        <div className="row justify-content-center">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12">                
        <form name="contactform" className="" onSubmit= {this.sendDetails.bind(this)}>
        <div className="form-row">
        <div className="form-group col-md-12">
           <div className="row">
            <div className="col-md-3">
            <label htmlFor="Vorname">Vorname <span className="required-star">*</span></label>
            </div>
            <div className="col-md-9">
            <input ref="first_name" type="text" className="form-control" id="Vorname" onChange={this.handleChange.bind(this, "first_name")} value={this.state.fields["first_name"]} placeholder="Vorname"/>
            <span style={{color: "red"}}>{this.state.errors["first_name"]}</span>
            </div>
            </div>
        </div>
        <div className="form-group col-md-12">
            <div className="row">
                <div className="col-md-3">
                <label htmlFor="Nachname">Nachname <span className="required-star">*</span></label>
                </div>
                <div className="col-md-9">
                <input ref="last_name" type="text" className="form-control" id="Nachname" placeholder="Nachname" onChange={this.handleChange.bind(this, "last_name")} value={this.state.fields["last_name"]}/>
                <span style={{color: "red"}}>{this.state.errors["first_name"]}</span>
                </div>
            </div>
        </div>
        <div className="form-group col-md-12">
        <div className="row">
            <div className="col-md-3">
            <label htmlFor="Adresszusatz">Adresszusatz</label>
            </div>
            <div className="col-md-9">
            <input type="text" className="form-control" ref="company" id="Firma" placeholder="Adresszusatz" onChange={this.handleChange.bind(this, "company")} value={this.state.fields["company"]}/>
            <span style={{color: "red"}}>{this.state.errors["company"]}</span>
            </div>
        </div>
        </div>
        <div className="form-group col-md-12">
        <div className="row">
            <div className="col-md-3">
            <label htmlFor="Adresse">Adresse <span className="required-star">*</span></label>
            </div>
            <div className="col-md-9">
            <input type="text" ref="address" className="form-control" id="Adresse" placeholder="Adresse" onChange={this.handleChange.bind(this, "address")} value={this.state.fields["address"]}/>
            <span style={{color: "red"}}>{this.state.errors["address"]}</span>
            </div>
        </div>
        </div>
        <div className="form-group col-md-12">
            <div className="row">
                <div className="col-md-3">
                <label htmlFor="Firma">PLZ/Ort <span className="required-star">*</span></label>
                </div>
                <div className="col-md-9">
                <div className="row">
                <div className="col-md-4">        
                <input type="text" ref="zip_code" className="form-control" id="PLZ" placeholder="PLZ" onChange={this.handleChange.bind(this, "zip_code")} value={this.state.fields["zip_code"]}/>
                <span style={{color: "red"}}>{this.state.errors["zip_code"]}</span>
                </div>
                <div className="col-md-8">
                <input type="text" className="form-control" ref="place" id="Ort" placeholder="Ort" onChange={this.handleChange.bind(this, "place")} value={this.state.fields["place"]}/>
                <span style={{color: "red"}}>{this.state.errors["place"]}</span>
                </div>
                </div>
                </div>
            </div>
        </div>
        <div className="form-group col-md-12">
            <div className="row">
                <div className="col-md-3">
                <label htmlFor="Land">Land</label>
                </div>
                <div className="col-md-9">
                <input type="text" className="form-control" ref="country" id="Land" placeholder="Land" onChange={this.handleChange.bind(this, "country")} value={this.state.fields["country"]}/>
                <span style={{color: "red"}}>{this.state.errors["country"]}</span>
                </div>
            </div>
        </div>
        <div className="form-group col-md-12">
            <div className="row">
                <div className="col-md-3">
                <label htmlFor="Email">Email <span className="required-star">*</span></label>
                </div>
                <div className="col-md-9">
                <input type="text" className="form-control" ref="email" id="Email" placeholder="Email" onChange={this.handleChange.bind(this, "email")} value={this.state.fields["email"]}/>
                <span style={{color: "red"}}>{this.state.errors["email"]}</span>
                </div>
            </div>
        </div>
        <div className="form-group col-md-12 text-center">
            <div className="row">
                <div className="form-group col-md-12">
                <button type="submit" className="btn btn-primary">Senden</button>
                </div>
            </div>
        </div>
        </div>
        </form>
        </div>        
        </div> 
        </div>
        <div className="text-center">     
          <Link to="https://www.biovision.ch/datenschutz/" className="link-live">Datenschutzhinweise</Link>
        </div>
      </div>
			</React.Fragment>
		)
		
	}	
}

export default SendGift;